/**
 * ``admin.*`` event schemas — frontend-emitted variants only.
 *
 * Backend-emitted admin events (invitation lifecycle, api_key
 * lifecycle, user lifecycle, security.configured, legal upload,
 * audit_logs.exported) live on the backend's Pydantic side (PR-11+).
 * Frontend only captures pageviews and the settings-tab save.
 *
 * Source of truth: ``plans/PLAN_POSTHOG_02_EVENT_CATALOG.md`` §
 * "admin.*", "Source" column = "frontend".
 */

import { z } from "zod";

import { BaseEventSchema } from "./base";
import { AdminSettingsTabProperty } from "./properties";

export const AdminTeamViewedSchema = BaseEventSchema.extend({
  event_name: z.literal("admin.team.viewed"),
  screen: z.string(),
});

export const AdminRolesViewedSchema = BaseEventSchema.extend({
  event_name: z.literal("admin.roles.viewed"),
  screen: z.string(),
});

export const AdminApiKeyViewedSchema = BaseEventSchema.extend({
  event_name: z.literal("admin.api_key.viewed"),
  screen: z.string(),
});

export const AdminSettingsViewedSchema = BaseEventSchema.extend({
  event_name: z.literal("admin.settings.viewed"),
  screen: z.string(),
  tab: AdminSettingsTabProperty,
});

export const AdminSettingsSavedSchema = BaseEventSchema.extend({
  event_name: z.literal("admin.settings.saved"),
  tab: AdminSettingsTabProperty,
});

export const AdminAuditLogsViewedSchema = BaseEventSchema.extend({
  event_name: z.literal("admin.audit_logs.viewed"),
  screen: z.string(),
});

export const adminEvents = [
  AdminTeamViewedSchema,
  AdminRolesViewedSchema,
  AdminApiKeyViewedSchema,
  AdminSettingsViewedSchema,
  AdminSettingsSavedSchema,
  AdminAuditLogsViewedSchema,
] as const;
